import { toString, Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type, record_type, bool_type, option_type, array_type, string_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { User as User_1, UserState, Role__ToDescription, Role, UpdatedUser, Workplace_$reflection, User_$reflection, UserState_$reflection } from "./Shared/SharedModels.jsx";
import { unwrap, toArray, defaultArg, map } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "./Toasts.jsx";
import { useCtx, ContextMsg } from "./Context.jsx";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { Workplace, toastServerError, User } from "./ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { SortDirection } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { compareTo, compare, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { sort, tryFind, map as map_1, contains } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { comparePrimitives, compare as compare_1, int32ToString, createObj, equals, stringHash } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { take, length, iterate, collect, toArray as toArray_1, tryHead, empty, append, singleton as singleton_1, delay, toList, forAll } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { Radio, RadioGroup, Divider, Checkbox, Body1Strong, PopoverSurface, PopoverTrigger, Popover, Input, Card, Tab, TabList, Title3, Option, Dropdown, Caption1, tokens, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, Tooltip, Spinner, Button, Badge, Text as Text$, Persona, Link, TableCellLayout, createTableColumn as createTableColumn_7 } from "@fluentui/react-components";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { isEmpty, singleton, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ArrowResetRegular, FilterRegular, SearchRegular, PersonProhibitedRegular, CheckmarkRegular } from "@fluentui/react-icons";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { dataGrid_items_Z6D8BD2B8 } from "./fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";
import { compareTo as compareTo_1 } from "./fable_modules/fable-library-js.4.29.0/Date.js";
import { nb } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { Array_distinct } from "./fable_modules/fable-library-js.4.29.0/Seq2.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Checkbox_toBool } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { AuditLog } from "./AuditTable.jsx";

class Filter extends Record {
    constructor(SearchTerm, Workplaces, Regions, State, IsAdmin) {
        super();
        this.SearchTerm = SearchTerm;
        this.Workplaces = Workplaces;
        this.Regions = Regions;
        this.State = State;
        this.IsAdmin = IsAdmin;
    }
}

function Filter_$reflection() {
    return record_type("ApproveUsers.Filter", [], Filter, () => [["SearchTerm", string_type], ["Workplaces", array_type(string_type)], ["Regions", array_type(string_type)], ["State", option_type(UserState_$reflection())], ["IsAdmin", option_type(bool_type)]]);
}

class Model extends Record {
    constructor(AllUsers, Workplaces, IsFetching, SelectedTab, Filter) {
        super();
        this.AllUsers = AllUsers;
        this.Workplaces = Workplaces;
        this.IsFetching = IsFetching;
        this.SelectedTab = SelectedTab;
        this.Filter = Filter;
    }
}

function Model_$reflection() {
    return record_type("ApproveUsers.Model", [], Model, () => [["AllUsers", array_type(User_$reflection())], ["Workplaces", array_type(Workplace_$reflection())], ["IsFetching", bool_type], ["SelectedTab", string_type], ["Filter", Filter_$reflection()]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateAllUsers", "UpdateWorkplaces", "UpdateIsFetching", "SelectTab", "UpdateFilter"];
    }
}

function Msg_$reflection() {
    return union_type("ApproveUsers.Msg", [], Msg, () => [[["Item", array_type(User_$reflection())]], [["Item", array_type(Workplace_$reflection())]], [["Item", bool_type]], [["Item", string_type]], [["Item", Filter_$reflection()]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.AllUsers, msg.fields[0], model.IsFetching, model.SelectedTab, model.Filter);
        case 2:
            return new Model(model.AllUsers, model.Workplaces, msg.fields[0], model.SelectedTab, model.Filter);
        case 3:
            return new Model(model.AllUsers, model.Workplaces, model.IsFetching, msg.fields[0], model.Filter);
        case 4:
            return new Model(model.AllUsers, model.Workplaces, model.IsFetching, model.SelectedTab, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Workplaces, model.IsFetching, model.SelectedTab, model.Filter);
    }
}

function init() {
    return new Model([], [], true, "awaiting", new Filter("", [], [], undefined, undefined));
}

export function updateEnabledUser(user, newState, callback, setIsSending, setCtx) {
    const updatedUser = new UpdatedUser(user.FirstName, user.LastName, user.Email, user.Phone, newState, user.Role, map((_arg) => _arg.Id, user.Workplace), map((_arg_1) => _arg_1.Id, user.Title));
    setIsSending(user.Id);
    const pr_1 = tap((res) => {
        try {
            if (res.tag === 1) {
                switch (res.fields[0].tag) {
                    case 1: {
                        errorToast(setCtx, `updateUser${user.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                        break;
                    }
                    case 2: {
                        errorToast(setCtx, `updateUser${user.Id}TitleNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig tittel", undefined);
                        break;
                    }
                    case 3: {
                        errorToast(setCtx, `updateUser${user.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                        break;
                    }
                    case 4: {
                        errorToast(setCtx, `updateUser${user.Id}InvalidEmail`, "Kunne ikke oppdatere bruker", "Ugyldig e-post", undefined);
                        break;
                    }
                    case 5: {
                        errorToast(setCtx, `updateUser${user.Id}Internal`, "Kunne ikke oppdatere bruker", "", undefined);
                        break;
                    }
                    default:
                        errorToast(setCtx, `updateUser${user.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
                }
            }
            else {
                callback(res.fields[0]);
                successToast(setCtx, `enableUser${user.Id}Success`, "Bruker oppdatert", `Brukeren ${user.FirstName} ${user.LastName} ble oppdatert`);
                const pr = tap((countRes) => {
                    if (countRes.tag === 1) {
                    }
                    else {
                        setCtx(new ContextMsg(10, [countRes.fields[0]]));
                    }
                }, startAsPromise(User.GetPendingApprovalCount()));
                void pr;
            }
        }
        finally {
            setIsSending(undefined);
        }
    }, startAsPromise(User.UpdateUser(user.Id, updatedUser)));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

export function updateUser(user, callback, setCtx) {
    let pr_2;
    const pr_1 = startAsPromise(User.UpdateUser(user.Id, new UpdatedUser(user.FirstName, user.LastName, user.Email, user.Phone, user.State, user.Role, map((_arg) => _arg.Id, user.Workplace), map((_arg_1) => _arg_1.Id, user.Title))));
    pr_2 = (pr_1.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, `updateUser${user.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, `updateUser${user.Id}TitleNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig tittel", undefined);
                    break;
                }
                case 3: {
                    errorToast(setCtx, `updateUser${user.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                    break;
                }
                case 4: {
                    errorToast(setCtx, `updateUser${user.Id}InvalidEmail`, "Kunne ikke oppdatere bruker", "Ugyldig e-post", undefined);
                    break;
                }
                case 5: {
                    errorToast(setCtx, `updateUser${user.Id}Internal`, "Kunne ikke oppdatere bruker", "", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, `updateUser${user.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
            }
        }
        else {
            callback(res.fields[0]);
            successToast(setCtx, `updateUser${user.Id}Success`, "Bruker oppdatert", `Brukeren ${user.FirstName} ${user.LastName} ble oppdatert`);
            const pr = tap((countRes) => {
                if (countRes.tag === 1) {
                }
                else {
                    setCtx(new ContextMsg(10, [countRes.fields[0]]));
                }
            }, startAsPromise(User.GetPendingApprovalCount()));
            void pr;
        }
        return res;
    }));
    void (pr_2.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function getWorkplaceName(user) {
    return defaultArg(map((_arg) => _arg.Name, user.Workplace), "Ingen arbeidsplass");
}

function getRegionName(user) {
    return defaultArg(map((_arg) => _arg.Region.Name, user.Workplace), "Ingen region");
}

function AllUsersTable(allUsersTableInputProps) {
    let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, createTableColumn_4, createTableColumn_5, createTableColumn_6, elems_6, el_61, tupledArg, value_232, elems_5, props_76, el_53, name_6, el_59;
    const dispatch = allUsersTableInputProps.dispatch;
    const model = allUsersTableInputProps.model;
    const patternInput = useCtx();
    const patternInput_1 = reactApi.useState(undefined);
    const isSending = patternInput_1[0];
    const patternInput_2 = reactApi.useState(["name", new SortDirection(0, [])]);
    let filteredUsers;
    const searchTerm = model.Filter.SearchTerm.trim().toLowerCase();
    filteredUsers = model.AllUsers.filter((u) => {
        let x_3;
        const name = (`${u.FirstName} ${u.LastName}`).toLowerCase();
        const workplace = getWorkplaceName(u);
        const region = getRegionName(u);
        if ((((isNullOrWhiteSpace(searchTerm) ? true : (name.indexOf(searchTerm) >= 0)) && ((model.Filter.Workplaces.length === 0) ? true : contains(workplace, model.Filter.Workplaces, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        }))) && ((model.Filter.Regions.length === 0) ? true : contains(region, model.Filter.Regions, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: stringHash,
        }))) && forAll((y_2) => equals(u.State, y_2), toArray(model.Filter.State))) {
            return forAll((x_3 = equals(u.Role, new Role(1, [])), (y_3) => (x_3 === y_3)), toArray(model.Filter.IsAdmin));
        }
        else {
            return false;
        }
    });
    const columns = ofArray([(createTableColumn = createTableColumn_7, createTableColumn({
        columnId: "name",
        compare: (delegateArg, delegateArg_1) => {
            const a = delegateArg;
            const b = delegateArg_1;
            return compare(`${a.FirstName} ${a.LastName}`, `${b.FirstName} ${b.LastName}`) | 0;
        },
        renderHeaderCell: () => "Navn",
        renderCell: (delegateArg_3) => {
            let elems_1, el_4, elems, el_2, el;
            const user = delegateArg_3;
            const el_6 = TableCellLayout;
            return createElement(el_6, {
                key: `${user.Id}-name`,
                children: singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 8 + "px ",
                    height: 100 + "%",
                }], (elems_1 = [(el_4 = Link, createElement(el_4, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(user.Id)]), 1)], (elems = [(el_2 = Persona, createElement(el_2, {
                    size: "small",
                    textAlignment: "center",
                    avatar: {
                        image: {
                            src: defaultArg(user.ThumbnailUrl, ""),
                        },
                    },
                    primaryText: (el = Text$, createElement(el, {
                        children: `${user.FirstName} ${user.LastName}`,
                        style: {
                            maxWidth: 180,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        wrap: false,
                    })),
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
            });
        },
    })), (createTableColumn_1 = createTableColumn_7, createTableColumn_1({
        columnId: "role",
        compare: (delegateArg_4, delegateArg_1_1) => compare(Role__ToDescription(delegateArg_4.Role), Role__ToDescription(delegateArg_1_1.Role)),
        renderHeaderCell: () => "Rolle",
        renderCell: (delegateArg_6) => {
            let el_8;
            const user_1 = delegateArg_6;
            const el_10 = TableCellLayout;
            return createElement(el_10, {
                key: `${user_1.Id}-role`,
                style: {
                    maxWidth: 380,
                    wordBreak: "break-all",
                },
                children: singleton((el_8 = Text$, createElement(el_8, {
                    children: Role__ToDescription(user_1.Role),
                }))),
            });
        },
    })), (createTableColumn_2 = createTableColumn_7, createTableColumn_2({
        columnId: "email",
        compare: (delegateArg_7, delegateArg_1_2) => compare(delegateArg_7.Email, delegateArg_1_2.Email),
        renderHeaderCell: () => "E-post",
        renderCell: (delegateArg_9) => {
            let el_12;
            const user_2 = delegateArg_9;
            const el_14 = TableCellLayout;
            return createElement(el_14, {
                key: `${user_2.Id}-email`,
                style: {
                    maxWidth: 380,
                    wordBreak: "break-all",
                },
                children: singleton((el_12 = Text$, createElement(el_12, {
                    children: user_2.Email,
                }))),
            });
        },
    })), (createTableColumn_3 = createTableColumn_7, createTableColumn_3({
        columnId: "workplace",
        compare: (delegateArg_10, delegateArg_1_3) => compare(getWorkplaceName(delegateArg_10), getWorkplaceName(delegateArg_1_3)),
        renderHeaderCell: () => "Arbeidsplass",
        renderCell: (delegateArg_12) => {
            let el_16;
            const user_3 = delegateArg_12;
            const el_18 = TableCellLayout;
            return createElement(el_18, {
                key: `${user_3.Id}-workplace`,
                children: singleton((el_16 = Text$, createElement(el_16, {
                    children: getWorkplaceName(user_3),
                }))),
            });
        },
    })), (createTableColumn_4 = createTableColumn_7, createTableColumn_4({
        columnId: "region",
        compare: (delegateArg_13, delegateArg_1_4) => compare(getRegionName(delegateArg_13), getRegionName(delegateArg_1_4)),
        renderHeaderCell: () => "Region",
        renderCell: (delegateArg_15) => {
            let el_20;
            const user_4 = delegateArg_15;
            const el_22 = TableCellLayout;
            return createElement(el_22, {
                key: `${user_4.Id}-region`,
                children: singleton((el_20 = Text$, createElement(el_20, {
                    children: getRegionName(user_4),
                }))),
            });
        },
    })), (createTableColumn_5 = createTableColumn_7, createTableColumn_5({
        columnId: "status",
        compare: (delegateArg_16, delegateArg_1_5) => compare_1(delegateArg_16.State, delegateArg_1_5.State),
        renderHeaderCell: () => "Status",
        renderCell: (delegateArg_18) => {
            const user_5 = delegateArg_18;
            const el_36 = TableCellLayout;
            return createElement(el_36, {
                key: `${user_5.Id}-status`,
                children: toList(delay(() => {
                    let el_30, el_28, el_34, el_32, el_26, el_24;
                    const matchValue = user_5.State;
                    return (matchValue.tag === 0) ? singleton_1((el_30 = Badge, createElement(el_30, {
                        appearance: "tint",
                        shape: "rounded",
                        color: "warning",
                        children: (el_28 = Text$, createElement(el_28, {
                            children: "Venter",
                        })),
                    }))) : ((matchValue.tag === 2) ? singleton_1((el_34 = Badge, createElement(el_34, {
                        appearance: "tint",
                        shape: "rounded",
                        color: "subtle",
                        children: (el_32 = Text$, createElement(el_32, {
                            children: "Deaktivert",
                        })),
                    }))) : singleton_1((el_26 = Badge, createElement(el_26, {
                        appearance: "tint",
                        shape: "rounded",
                        color: "success",
                        children: (el_24 = Text$, createElement(el_24, {
                            children: "Aktiv",
                        })),
                    }))));
                })),
            });
        },
    })), (createTableColumn_6 = createTableColumn_7, createTableColumn_6({
        columnId: "action",
        renderHeaderCell: () => "",
        renderCell: (delegateArg_20) => {
            const user_6 = delegateArg_20;
            const el_51 = TableCellLayout;
            return createElement(el_51, {
                key: `action-${user_6.Id}`,
                children: toList(delay(() => {
                    let el_49, matchValue_1;
                    const canApprove = (equals(user_6.State, new UserState(0, [])) ? true : equals(user_6.State, new UserState(2, []))) && (user_6.Workplace != null);
                    const canDeactivate = equals(user_6.State, new UserState(1, []));
                    const isSelf = user_6.Id === patternInput[0].User.Id;
                    const isDisabled = ((user_6.Workplace == null) ? true : (isSending != null)) ? true : (canDeactivate && isSelf);
                    const newState = canApprove ? (new UserState(1, [])) : (new UserState(2, []));
                    const buttonText = canApprove ? "Godkjenn" : "Sett inaktiv";
                    let toggleEnabledButton;
                    const el_46 = Button;
                    toggleEnabledButton = createElement(el_46, createObj(toList(delay(() => append(singleton_1(["disabled", isDisabled]), delay(() => append(singleton_1(["size", "small"]), delay(() => append(canApprove ? singleton_1(["appearance", "primary"]) : empty(), delay(() => {
                        let el_38, el_40;
                        return append(singleton_1(["icon", canApprove ? ((el_38 = CheckmarkRegular, createElement(el_38, {}))) : ((el_40 = PersonProhibitedRegular, createElement(el_40, {})))]), delay(() => append(singleton_1(["onClick", (_arg_7) => {
                            updateEnabledUser(user_6, newState, (_arg_8) => {
                                dispatch(new Msg(0, [map_1((u_1) => {
                                    if (user_6.Id === u_1.Id) {
                                        return new User_1(user_6.Id, user_6.KeycloakId, user_6.FirstName, user_6.LastName, newState, user_6.Role, user_6.RealRole, user_6.Email, user_6.Phone, user_6.ImageUrl, user_6.ThumbnailUrl, user_6.Workplace, user_6.Title, user_6.HasMaterialAccess, user_6.Inserted);
                                    }
                                    else {
                                        return u_1;
                                    }
                                }, model.AllUsers)]));
                            }, patternInput_1[1], patternInput[1]);
                        }]), delay(() => {
                            let elems_2;
                            return singleton_1((elems_2 = toList(delay(() => {
                                let uid_1, el_42, el_44;
                                return (isSending != null) ? ((isSending === user_6.Id) ? ((uid_1 = (isSending | 0), singleton_1((el_42 = Spinner, createElement(el_42, {
                                    size: "extra-small",
                                }))))) : singleton_1((el_44 = Text$, createElement(el_44, {
                                    children: buttonText,
                                })))) : singleton_1((el_44 = Text$, createElement(el_44, {
                                    children: buttonText,
                                })));
                            })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))]));
                        }))));
                    }))))))))));
                    return (canDeactivate && isSelf) ? singleton_1((el_49 = Tooltip, createElement(el_49, createObj(ofArray([["content", "Kan ikke endres på egen konto"], (matchValue_1 = tryHead([toggleEnabledButton]), (matchValue_1 == null) ? ["children", defaultOf()] : ["children", matchValue_1])]))))) : singleton_1(toggleEnabledButton);
                })),
            });
        },
    }))]);
    return createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        overflowX: "auto",
    }], (elems_6 = [(el_61 = DataGrid, createElement(el_61, createObj(ofArray([dataGrid_items_Z6D8BD2B8(filteredUsers), ["columns", toArray_1(columns)], ["sortable", true], (tupledArg = patternInput_2[0], ["sortState", {
        sortColumn: unwrap(tupledArg[0]),
        sortDirection: tupledArg[1],
    }]), ["onSortChange", (delegateArg_21, delegateArg_1_6) => {
        const sortState_1 = delegateArg_1_6;
        patternInput_2[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["resizableColumns", true], (value_232 = ofArray([["name", ofArray([["minWidth", 150], ["defaultWidth", 180], ["idealWidth", 250]])], ["role", ofArray([["minWidth", 90], ["defaultWidth", 90], ["idealWidth", 90]])], ["email", ofArray([["minWidth", 180], ["defaultWidth", 200], ["idealWidth", 300]])], ["workplace", ofArray([["minWidth", 120], ["defaultWidth", 150], ["idealWidth", 200]])], ["region", ofArray([["minWidth", 100], ["defaultWidth", 120], ["idealWidth", 180]])], ["status", ofArray([["minWidth", 90], ["defaultWidth", 90], ["idealWidth", 90]])], ["action", ofArray([["minWidth", 120], ["defaultWidth", 120], ["idealWidth", 120]])]]), ["columnSizingOptions", isEmpty(value_232) ? {} : createObj(toList(delay(() => collect((matchValue_2) => singleton_1([matchValue_2[0], createObj(matchValue_2[1])]), value_232))))]), (elems_5 = [(props_76 = singleton((el_53 = DataGridRow, createElement(el_53, {
        children: (delegateArg_22, delegateArg_1_7) => {
            const props_71 = singleton(delegateArg_22.renderHeaderCell());
            const name_4 = DataGridHeaderCell;
            return createElement(name_4, {
                children: reactApi.Children.toArray(Array.from(props_71)),
            });
        },
    }))), (name_6 = DataGridHeader, createElement(name_6, {
        children: reactApi.Children.toArray(Array.from(props_76)),
    }))), (el_59 = DataGridBody, createElement(el_59, {
        children: (delegateArg_24) => {
            const trd = delegateArg_24;
            const el_57 = DataGridRow;
            return createElement(el_57, {
                key: trd.rowId,
                children: (delegateArg_23, delegateArg_1_8) => {
                    let elems_4;
                    const tcd_1 = delegateArg_23;
                    const el_55 = DataGridCell;
                    return createElement(el_55, createObj(ofArray([["key", tcd_1.columnId], (elems_4 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function UserApprovalTable(userApprovalTableInputProps) {
    let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, createTableColumn_4, createTableColumn_5, createTableColumn_6, elems_6, el_61, tupledArg, value_224, elems_5, props_76, el_53, name_4, el_59;
    const dispatch = userApprovalTableInputProps.dispatch;
    const model = userApprovalTableInputProps.model;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const isSending = patternInput_1[0];
    const patternInput_2 = reactApi.useState(["approved", new SortDirection(0, [])]);
    const columns = ofArray([(createTableColumn = createTableColumn_7, createTableColumn({
        columnId: "approved",
        compare: (delegateArg, delegateArg_1) => compareTo(toString(delegateArg.State), toString(delegateArg_1.State)),
        renderHeaderCell: () => "",
        renderCell: (delegateArg_3) => {
            const user = delegateArg_3;
            const el_2 = TableCellLayout;
            return createElement(el_2, {
                key: `${user.FirstName}-approved`,
                children: toList(delay(() => {
                    let el;
                    return (equals(user.State, new UserState(1, [])) && (user.Workplace != null)) ? singleton_1((el = CheckmarkRegular, createElement(el, {
                        primaryFill: tokens.colorBrandForeground2,
                    }))) : empty();
                })),
            });
        },
    })), (createTableColumn_1 = createTableColumn_7, createTableColumn_1({
        columnId: "name",
        compare: (delegateArg_4, delegateArg_1_1) => {
            const a_1 = delegateArg_4;
            const b_1 = delegateArg_1_1;
            return compare(`${a_1.FirstName} ${a_1.LastName}`, `${b_1.FirstName} ${b_1.LastName}`) | 0;
        },
        renderHeaderCell: () => "Navn",
        renderCell: (delegateArg_6) => {
            let el_8, el_4, el_6;
            const user_1 = delegateArg_6;
            const el_10 = TableCellLayout;
            return createElement(el_10, {
                key: `${user_1.FirstName} ${user_1.LastName}`,
                children: singleton((el_8 = Persona, createElement(el_8, {
                    size: "small",
                    avatar: {
                        color: "colorful",
                        image: {
                            src: defaultArg(user_1.ThumbnailUrl, ""),
                        },
                    },
                    primaryText: (el_4 = Text$, createElement(el_4, {
                        children: `${user_1.FirstName} ${user_1.LastName}`,
                        style: {
                            maxWidth: 200,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        wrap: false,
                    })),
                    secondaryText: (el_6 = Caption1, createElement(el_6, {
                        children: user_1.Email,
                        style: {
                            maxWidth: 200,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        wrap: false,
                    })),
                }))),
            });
        },
    })), (createTableColumn_2 = createTableColumn_7, createTableColumn_2({
        columnId: "region",
        compare: (delegateArg_7, delegateArg_1_2) => compareTo(defaultArg(map((wp) => (`${wp.Region.Name}`), delegateArg_7.Workplace), ""), defaultArg(map((wp_1) => (`${wp_1.Region.Name}`), delegateArg_1_2.Workplace), "")),
        renderHeaderCell: () => "Region",
        renderCell: (delegateArg_9) => {
            let el_12;
            const user_2 = delegateArg_9;
            const el_14 = TableCellLayout;
            return createElement(el_14, {
                key: `${user_2.FirstName}-region`,
                children: singleton((el_12 = Text$, createElement(el_12, {
                    children: defaultArg(map((_arg_3) => _arg_3.Region.Name, user_2.Workplace), ""),
                }))),
            });
        },
    })), (createTableColumn_3 = createTableColumn_7, createTableColumn_3({
        columnId: "workplace",
        compare: (delegateArg_10, delegateArg_1_3) => {
            const matchValue = delegateArg_10.Workplace;
            const matchValue_1 = delegateArg_1_3.Workplace;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    const x = matchValue;
                    const y = matchValue_1;
                    return compare(x.Name, y.Name) | 0;
                }
                else {
                    return 1;
                }
            }
            else if (matchValue_1 != null) {
                return -1;
            }
            else {
                return 0;
            }
        },
        renderHeaderCell: () => "Arbeidsplass",
        renderCell: (delegateArg_12) => {
            let el_20, elems_1;
            const user_3 = delegateArg_12;
            const el_22 = TableCellLayout;
            return createElement(el_22, {
                key: defaultArg(map((_arg_5) => _arg_5.Name, user_3.Workplace), "Missing"),
                children: singleton((el_20 = Dropdown, createElement(el_20, createObj(ofArray([["size", "small"], ["style", {
                    minWidth: 150,
                }], ["appearance", "underline"], ["value", defaultArg(map((_arg_6) => _arg_6.Name, user_3.Workplace), "")], ["onOptionSelect", (_arg_7, value_1_33) => {
                    iterate((selected) => {
                        updateUser(new User_1(user_3.Id, user_3.KeycloakId, user_3.FirstName, user_3.LastName, user_3.State, user_3.Role, user_3.RealRole, user_3.Email, user_3.Phone, user_3.ImageUrl, user_3.ThumbnailUrl, tryFind((wp_2) => (wp_2.Name === selected), model.Workplaces), user_3.Title, user_3.HasMaterialAccess, user_3.Inserted), (updatedUser) => {
                            dispatch(new Msg(0, [map_1((u) => {
                                if (u.Id === updatedUser.Id) {
                                    return updatedUser;
                                }
                                else {
                                    return u;
                                }
                            }, model.AllUsers)]));
                            if (updatedUser.Id === ctx.User.Id) {
                                setCtx(new ContextMsg(2, [updatedUser]));
                            }
                        }, setCtx);
                    }, toArray(value_1_33.optionValue));
                }], (elems_1 = toList(delay(() => map_1((wp_4) => {
                    let elems, el_16;
                    const el_18 = Option;
                    return createElement(el_18, createObj(ofArray([["text", wp_4.Name], ["disabled", defaultArg(map((userWp) => (userWp.Id === wp_4.Id), user_3.Workplace), false)], ["value", wp_4.Name], (elems = [(el_16 = Text$, createElement(el_16, {
                        children: wp_4.Name,
                        wrap: false,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
                }, model.Workplaces))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))),
            });
        },
    })), (createTableColumn_4 = createTableColumn_7, createTableColumn_4({
        columnId: "inserted",
        compare: (delegateArg_13, delegateArg_1_4) => compareTo_1(delegateArg_13.Inserted, delegateArg_1_4.Inserted),
        renderHeaderCell: () => "Opprettet",
        renderCell: (delegateArg_15) => {
            let el_24, locale, formatOptions;
            const user_4 = delegateArg_15;
            const el_26 = TableCellLayout;
            return createElement(el_26, {
                key: toString(user_4.Inserted),
                children: singleton((el_24 = Text$, createElement(el_24, {
                    children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(user_4.Inserted, "dd MMMM yyyy", formatOptions))))}`,
                }))),
            });
        },
    })), (createTableColumn_5 = createTableColumn_7, createTableColumn_5({
        columnId: "status",
        renderHeaderCell: () => "Status",
        renderCell: (delegateArg_17) => {
            const user_5 = delegateArg_17;
            const el_38 = TableCellLayout;
            return createElement(el_38, {
                key: `${user_5.Id}-status`,
                children: toList(delay(() => {
                    let el_28, el_30, el_32, el_34, el_36;
                    const matchValue_3 = user_5.State;
                    const matchValue_4 = user_5.Workplace;
                    let matchResult;
                    switch (matchValue_3.tag) {
                        case 0: {
                            if (matchValue_4 != null) {
                                matchResult = 2;
                            }
                            else {
                                matchResult = 1;
                            }
                            break;
                        }
                        case 2: {
                            if (matchValue_4 != null) {
                                matchResult = 3;
                            }
                            else {
                                matchResult = 1;
                            }
                            break;
                        }
                        default:
                            if (matchValue_4 != null) {
                                matchResult = 4;
                            }
                            else {
                                matchResult = 0;
                            }
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton_1((el_28 = Text$, createElement(el_28, {
                                children: "Mangler arbeidsplass",
                            })));
                        case 1:
                            return singleton_1((el_30 = Text$, createElement(el_30, {
                                children: "Mangler arbeidsplass",
                            })));
                        case 2:
                            return singleton_1((el_32 = Text$, createElement(el_32, {
                                children: "Mangler godkjenning",
                            })));
                        case 3:
                            return singleton_1((el_34 = Text$, createElement(el_34, {
                                children: "Deaktivert",
                            })));
                        default:
                            return singleton_1((el_36 = Text$, createElement(el_36, {
                                children: `${Role__ToDescription(user_5.Role)}`,
                            })));
                    }
                })),
            });
        },
    })), (createTableColumn_6 = createTableColumn_7, createTableColumn_6({
        columnId: "approve",
        renderHeaderCell: () => "",
        renderCell: (delegateArg_19) => {
            const user_6 = delegateArg_19;
            const el_51 = TableCellLayout;
            return createElement(el_51, {
                key: `approve-${user_6.Id}`,
                children: toList(delay(() => {
                    let el_49, matchValue_7;
                    const canApprove = (equals(user_6.State, new UserState(0, [])) ? true : equals(user_6.State, new UserState(2, []))) && (user_6.Workplace != null);
                    const canDeactivate = equals(user_6.State, new UserState(1, []));
                    const isSelf = user_6.Id === ctx.User.Id;
                    const isDisabled = ((user_6.Workplace == null) ? true : (isSending != null)) ? true : (canDeactivate && isSelf);
                    const newState = canApprove ? (new UserState(1, [])) : (new UserState(2, []));
                    const buttonText = canApprove ? "Godkjenn" : "Sett inaktiv";
                    let toggleEnabledButton;
                    const el_46 = Button;
                    toggleEnabledButton = createElement(el_46, createObj(toList(delay(() => append(singleton_1(["disabled", isDisabled]), delay(() => append(singleton_1(["size", "small"]), delay(() => {
                        let matchValue_6, uid_1, elems_2, el_40;
                        return append((matchValue_6 = isSending, (matchValue_6 != null) ? ((matchValue_6 === user_6.Id) ? ((uid_1 = (matchValue_6 | 0), singleton_1((elems_2 = [(el_40 = Spinner, createElement(el_40, {
                            size: "extra-small",
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])))) : singleton_1(["children", buttonText])) : singleton_1(["children", buttonText])), delay(() => {
                            let el_42, el_44;
                            return append(singleton_1(["icon", canApprove ? ((el_42 = CheckmarkRegular, createElement(el_42, {}))) : ((el_44 = PersonProhibitedRegular, createElement(el_44, {})))]), delay(() => append(canApprove ? singleton_1(["appearance", "primary"]) : empty(), delay(() => singleton_1(["onClick", (_arg_11) => {
                                updateEnabledUser(user_6, newState, (_arg_12) => {
                                    dispatch(new Msg(0, [map_1((u_1) => {
                                        if (user_6.Id === u_1.Id) {
                                            return new User_1(user_6.Id, user_6.KeycloakId, user_6.FirstName, user_6.LastName, newState, user_6.Role, user_6.RealRole, user_6.Email, user_6.Phone, user_6.ImageUrl, user_6.ThumbnailUrl, user_6.Workplace, user_6.Title, user_6.HasMaterialAccess, user_6.Inserted);
                                        }
                                        else {
                                            return u_1;
                                        }
                                    }, model.AllUsers)]));
                                }, patternInput_1[1], setCtx);
                            }])))));
                        }));
                    }))))))));
                    return (canDeactivate && isSelf) ? singleton_1((el_49 = Tooltip, createElement(el_49, createObj(ofArray([["content", "Kan ikke endres på egen konto"], (matchValue_7 = tryHead([toggleEnabledButton]), (matchValue_7 == null) ? ["children", defaultOf()] : ["children", matchValue_7])]))))) : singleton_1(toggleEnabledButton);
                })),
            });
        },
    }))]);
    const searchTerm = model.Filter.SearchTerm.trim().toLowerCase();
    const filteredItems = model.AllUsers.filter((u_2) => {
        let x_4;
        let stateMatch;
        const matchValue_8 = model.SelectedTab;
        stateMatch = ((matchValue_8 === "awaiting") ? equals(u_2.State, new UserState(0, [])) : ((matchValue_8 === "deactivated") && equals(u_2.State, new UserState(2, []))));
        let searchMatch;
        if (isNullOrWhiteSpace(searchTerm)) {
            searchMatch = true;
        }
        else {
            const name = (`${u_2.FirstName} ${u_2.LastName}`).toLowerCase();
            searchMatch = (name.indexOf(searchTerm) >= 0);
        }
        const workplace = getWorkplaceName(u_2);
        const region = getRegionName(u_2);
        if ((((stateMatch && searchMatch) && ((model.Filter.Workplaces.length === 0) ? true : contains(workplace, model.Filter.Workplaces, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: stringHash,
        }))) && ((model.Filter.Regions.length === 0) ? true : contains(region, model.Filter.Regions, {
            Equals: (x_2, y_2) => (x_2 === y_2),
            GetHashCode: stringHash,
        }))) && forAll((y_3) => equals(u_2.State, y_3), toArray(model.Filter.State))) {
            return forAll((x_4 = equals(u_2.Role, new Role(1, [])), (y_4) => (x_4 === y_4)), toArray(model.Filter.IsAdmin));
        }
        else {
            return false;
        }
    });
    return createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        overflowX: "auto",
    }], (elems_6 = [(el_61 = DataGrid, createElement(el_61, createObj(ofArray([dataGrid_items_Z6D8BD2B8(filteredItems), ["columns", toArray_1(columns)], ["sortable", true], ["resizableColumnsOptions", {
        autoFitColumns: true,
    }], (tupledArg = patternInput_2[0], ["sortState", {
        sortColumn: unwrap(tupledArg[0]),
        sortDirection: tupledArg[1],
    }]), ["onSortChange", (delegateArg_20, delegateArg_1_5) => {
        const sortState_1 = delegateArg_1_5;
        patternInput_2[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["resizableColumns", true], (value_224 = ofArray([["approved", ofArray([["minWidth", 20], ["defaultWidth", 20], ["idealWidth", 20]])], ["region", ofArray([["minWidth", 75], ["defaultWidth", 75], ["idealWidth", 75]])], ["name", ofArray([["minWidth", 125], ["defaultWidth", 150], ["idealWidth", 250]])], ["workplace", ofArray([["minWidth", 125], ["defaultWidth", 150], ["idealWidth", 200]])]]), ["columnSizingOptions", isEmpty(value_224) ? {} : createObj(toList(delay(() => collect((matchValue_9) => singleton_1([matchValue_9[0], createObj(matchValue_9[1])]), value_224))))]), (elems_5 = [(props_76 = singleton((el_53 = DataGridRow, createElement(el_53, {
        children: (delegateArg_21, delegateArg_1_6) => {
            const props_71 = singleton(delegateArg_21.renderHeaderCell());
            const name_2 = DataGridHeaderCell;
            return createElement(name_2, {
                children: reactApi.Children.toArray(Array.from(props_71)),
            });
        },
    }))), (name_4 = DataGridHeader, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_76)),
    }))), (el_59 = DataGridBody, createElement(el_59, {
        children: (delegateArg_23) => {
            const trd = delegateArg_23;
            const el_57 = DataGridRow;
            return createElement(el_57, {
                key: trd.rowId,
                children: (delegateArg_22, delegateArg_1_7) => {
                    let elems_4;
                    const tcd_1 = delegateArg_22;
                    const el_55 = DataGridCell;
                    return createElement(el_55, createObj(ofArray([["key", tcd_1.columnId], (elems_4 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function View() {
    let elems_16, elems_1, elems, el, el_2, el_16, elems_4, el_10, elems_3, elems_2, el_12, el_14, el_75, elems_13, el_20, el_18, elems_12, el_66, elems_10, el_26, el_24, el_22, el_64, elems_9, elemsToUse, el_73, matchValue_6, el_70, el_68, el_77, elems_14, el_79, elems_15;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const workplaces = sort(Array_distinct(map_1(getWorkplaceName, model_1.AllUsers), {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), {
        Compare: comparePrimitives,
    });
    const regions = sort(Array_distinct(map_1(getRegionName, model_1.AllUsers), {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: stringHash,
    }), {
        Compare: comparePrimitives,
    });
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(User.GetAll());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                dispatch(new Msg(2, [false]));
            }
            else {
                dispatch(new Msg(0, [res.fields[0]]));
                dispatch(new Msg(2, [false]));
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(Workplace.GetAllWorkplaces());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Noe gikk galt", "Kunne ikke hente arbeidsplasser", undefined);
            }
            else {
                dispatch(new Msg(1, [res_1.fields[0]]));
            }
            return res_1;
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_16 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [(el = Title3, createElement(el, {
        children: "Administrer brukere",
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: "Godkjenn, deaktiver og administrer brukere",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_16 = TabList, createElement(el_16, createObj(ofArray([["selectedValue", model_1.SelectedTab], ["onTabSelect", (_arg_1, value_1_3) => {
        const matchValue = value_1_3.value;
        switch (matchValue) {
            case "awaiting": {
                dispatch(new Msg(3, ["awaiting"]));
                break;
            }
            case "deactivated": {
                dispatch(new Msg(3, ["deactivated"]));
                break;
            }
            case "all": {
                dispatch(new Msg(3, ["all"]));
                break;
            }
            default:
                undefined;
        }
    }], (elems_4 = [(el_10 = Tab, createElement(el_10, createObj(ofArray([["value", "awaiting"], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 8 + "px ",
    }], (elems_2 = toList(delay(() => {
        let el_4;
        return append(singleton_1((el_4 = Text$, createElement(el_4, {
            children: "Venter på godkjenning",
        }))), delay(() => {
            let el_8, el_6;
            return (ctx.PendingApprovalCount > 0) ? singleton_1((el_8 = Badge, createElement(el_8, {
                size: "small",
                appearance: "filled",
                shape: "rounded",
                children: (el_6 = Text$, createElement(el_6, {
                    children: int32ToString(ctx.PendingApprovalCount),
                })),
            }))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (el_12 = Tab, createElement(el_12, {
        value: "deactivated",
        children: "Deaktiverte",
    })), (el_14 = Tab, createElement(el_14, {
        value: "all",
        children: "Alle brukere",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_75 = Card, createElement(el_75, createObj(ofArray([["orientation", "horizontal"], ["style", {
        width: 100 + "%",
        display: "flex",
        justifyContent: "space-between",
    }], (elems_13 = [(el_20 = Input, createElement(el_20, {
        contentBefore: (el_18 = SearchRegular, createElement(el_18, {})),
        placeholder: "Søk etter bruker...",
        value: model_1.Filter.SearchTerm,
        onChange: (_arg_2, value_1_13) => {
            let bind$0040;
            const v = value_1_13;
            dispatch(new Msg(4, [(bind$0040 = model_1.Filter, new Filter(isNullOrWhiteSpace(v.value) ? "" : v.value, bind$0040.Workplaces, bind$0040.Regions, bind$0040.State, bind$0040.IsAdmin))]));
        },
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 5 + "px ",
    }], (elems_12 = [(el_66 = Popover, createElement(el_66, createObj(ofArray([["trapFocus", true], ["positioning", {
        position: "below",
        align: "start",
    }], (elems_10 = [(el_26 = PopoverTrigger, createElement(el_26, {
        children: (el_24 = Button, createElement(el_24, {
            icon: (el_22 = FilterRegular, createElement(el_22, {})),
            iconPosition: "before",
            children: "Filter",
        })),
    })), (el_64 = PopoverSurface, createElement(el_64, createObj(ofArray([["style", {
        minWidth: 320,
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_9 = toList(delay(() => {
        let el_28;
        return append(singleton_1((el_28 = Body1Strong, createElement(el_28, {
            children: "Arbeidsplass",
        }))), delay(() => {
            let elems_5;
            return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 4 + "px ",
                maxHeight: 200,
                overflowY: "auto",
            }], (elems_5 = toList(delay(() => map_1((name_6) => {
                const el_30 = Checkbox;
                return createElement(el_30, {
                    label: name_6,
                    checked: contains(name_6, model_1.Filter.Workplaces, {
                        Equals: (x_4, y_4) => (x_4 === y_4),
                        GetHashCode: stringHash,
                    }),
                    onChange: (_arg_3, c) => {
                        let bind$0040_1;
                        dispatch(new Msg(4, [(bind$0040_1 = model_1.Filter, new Filter(bind$0040_1.SearchTerm, Checkbox_toBool(c) ? toArray_1(delay(() => append(model_1.Filter.Workplaces, delay(() => singleton_1(name_6))))) : model_1.Filter.Workplaces.filter((y_5) => (name_6 !== y_5)), bind$0040_1.Regions, bind$0040_1.State, bind$0040_1.IsAdmin))]));
                    },
                });
            }, workplaces))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                let el_32;
                return append(singleton_1((el_32 = Divider, createElement(el_32, {}))), delay(() => {
                    let el_34;
                    return append(singleton_1((el_34 = Body1Strong, createElement(el_34, {
                        children: "Region",
                    }))), delay(() => {
                        let elems_6;
                        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4 + "px ",
                            maxHeight: 200,
                            overflowY: "auto",
                        }], (elems_6 = toList(delay(() => map_1((name_9) => {
                            const el_36 = Checkbox;
                            return createElement(el_36, {
                                label: name_9,
                                checked: contains(name_9, model_1.Filter.Regions, {
                                    Equals: (x_5, y_6) => (x_5 === y_6),
                                    GetHashCode: stringHash,
                                }),
                                onChange: (_arg_4, c_1) => {
                                    let bind$0040_2;
                                    dispatch(new Msg(4, [(bind$0040_2 = model_1.Filter, new Filter(bind$0040_2.SearchTerm, bind$0040_2.Workplaces, Checkbox_toBool(c_1) ? toArray_1(delay(() => append(model_1.Filter.Regions, delay(() => singleton_1(name_9))))) : model_1.Filter.Regions.filter((y_7) => (name_9 !== y_7)), bind$0040_2.State, bind$0040_2.IsAdmin))]));
                                },
                            });
                        }, regions))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let el_38;
                            return append(singleton_1((el_38 = Divider, createElement(el_38, {}))), delay(() => {
                                let el_40;
                                return append(singleton_1((el_40 = Body1Strong, createElement(el_40, {
                                    children: "Status",
                                }))), delay(() => {
                                    let el_50, matchValue_1, elems_7, el_42, el_44, el_46, el_48;
                                    return append(singleton_1((el_50 = RadioGroup, createElement(el_50, createObj(ofArray([["value", (matchValue_1 = model_1.Filter.State, (matchValue_1 != null) ? ((matchValue_1.tag === 1) ? "enabled" : ((matchValue_1.tag === 2) ? "deactivated" : "new")) : "alle")], ["onChange", (_arg_5, value_1_24) => {
                                        let bind$0040_3, matchValue_2;
                                        dispatch(new Msg(4, [(bind$0040_3 = model_1.Filter, new Filter(bind$0040_3.SearchTerm, bind$0040_3.Workplaces, bind$0040_3.Regions, (matchValue_2 = value_1_24.value, (matchValue_2 === "new") ? (new UserState(0, [])) : ((matchValue_2 === "enabled") ? (new UserState(1, [])) : ((matchValue_2 === "deactivated") ? (new UserState(2, [])) : undefined))), bind$0040_3.IsAdmin))]));
                                    }], (elems_7 = [(el_42 = Radio, createElement(el_42, {
                                        value: "alle",
                                        label: "Alle",
                                    })), (el_44 = Radio, createElement(el_44, {
                                        value: "new",
                                        label: "Venter på godkjenning",
                                    })), (el_46 = Radio, createElement(el_46, {
                                        value: "enabled",
                                        label: "Aktive",
                                    })), (el_48 = Radio, createElement(el_48, {
                                        value: "deactivated",
                                        label: "Deaktiverte",
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))), delay(() => {
                                        let el_52;
                                        return append(singleton_1((el_52 = Divider, createElement(el_52, {}))), delay(() => {
                                            let el_54;
                                            return append(singleton_1((el_54 = Body1Strong, createElement(el_54, {
                                                children: "Admin",
                                            }))), delay(() => {
                                                let el_62, matchValue_3, elems_8, el_56, el_58, el_60;
                                                return singleton_1((el_62 = RadioGroup, createElement(el_62, createObj(ofArray([["value", (matchValue_3 = model_1.Filter.IsAdmin, (matchValue_3 != null) ? (matchValue_3 ? "admin" : "user") : "alle")], ["layout", "horizontal"], ["onChange", (_arg_6, value_1_34) => {
                                                    let bind$0040_4, matchValue_4;
                                                    dispatch(new Msg(4, [(bind$0040_4 = model_1.Filter, new Filter(bind$0040_4.SearchTerm, bind$0040_4.Workplaces, bind$0040_4.Regions, bind$0040_4.State, (matchValue_4 = value_1_34.value, (matchValue_4 === "admin") ? true : ((matchValue_4 === "user") ? false : undefined))))]));
                                                }], (elems_8 = [(el_56 = Radio, createElement(el_56, {
                                                    value: "alle",
                                                    label: "Alle",
                                                })), (el_58 = Radio, createElement(el_58, {
                                                    value: "admin",
                                                    label: "Kun admin",
                                                })), (el_60 = Radio, createElement(el_60, {
                                                    value: "user",
                                                    label: "Kun ikke admin",
                                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])))));
                                            }));
                                        }));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))], (elemsToUse = ((length(elems_10) <= 2) ? elems_10 : take(2, elems_10)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])))), (el_73 = Tooltip, createElement(el_73, createObj(ofArray([["content", "Tilbakestill"], (matchValue_6 = tryHead([(el_70 = Button, createElement(el_70, {
        icon: (el_68 = ArrowResetRegular, createElement(el_68, {})),
        onClick: (_arg_7) => {
            dispatch(new Msg(4, [new Filter("", [], [], undefined, undefined)]));
        },
        disabled: ((((model_1.Filter.SearchTerm === "") && (model_1.Filter.Workplaces.length === 0)) && (model_1.Filter.Regions.length === 0)) && (model_1.Filter.State == null)) && (model_1.Filter.IsAdmin == null),
    }))]), (matchValue_6 == null) ? ["children", defaultOf()] : ["children", matchValue_6])]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])])))), (el_77 = Card, createElement(el_77, createObj(singleton((elems_14 = toList(delay(() => ((model_1.SelectedTab === "all") ? singleton_1(createElement(AllUsersTable, {
        model: model_1,
        dispatch: dispatch,
    })) : singleton_1(createElement(UserApprovalTable, {
        model: model_1,
        dispatch: dispatch,
    }))))), ["children", reactApi_1.Children.toArray(Array.from(elems_14))]))))), (el_79 = Card, createElement(el_79, createObj(singleton((elems_15 = [createElement(AuditLog, {
        tableName: "user",
    })], ["children", reactApi_1.Children.toArray(Array.from(elems_15))])))))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
}

//# sourceMappingURL=ApproveUsers.jsx.map
